import { useTonWallet } from "@tonconnect/ui-react";
import { createContext, useContext } from "react";
import useStore from "../common/useStore";
import useTonClientStore from "../TonClientStore/useTonClientStore";
import WalletStore from "./WalletStore";

const WalletStoreContext = createContext<WalletStore | undefined>(undefined);

export interface WalletStoreProviderProps {
  children: React.ReactNode;
}

export const WalletStoreProvider = ({
  children,
}: WalletStoreProviderProps): JSX.Element => {
  const tonClientStore = useTonClientStore();
  const wallet = useTonWallet();
  const walletStore = useStore(WalletStore, [tonClientStore]);

  // useEffect(() => {
  //   walletStore.setUserAddress(wallet?.account.address);
  //   walletStore.loadTonBallance();
  //   walletStore.loadUsdtBallance();
  //   walletStore.loadRaffBallance();
  // }, [wallet?.account.address, walletStore, walletStore.isLoading]);

  return (
    <WalletStoreContext.Provider value={walletStore}>
      {children}
    </WalletStoreContext.Provider>
  );
};

const useWalletStore = () => {
  const store = useContext(WalletStoreContext);

  if (!store)
    throw new Error(
      "useWalletStore should be called inside WalletStoreProvider"
    );

  return store;
};

export default useWalletStore;
